module.exports = __webpack_public_path__ + "static/Mauer2@2x.5d2c1288.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/PageHeader/MauerBack/Mauer2@2x.png
// module id = 431
// module chunks = 35783957827783